import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hospital-visit-form" }
const _hoisted_2 = { class: "hospital-visit-form-caution" }
const _hoisted_3 = { class: "hospital-visit-form-label" }
const _hoisted_4 = { for: "visit-date" }
const _hoisted_5 = { class: "hospital-visit-form-calendar-container" }
const _hoisted_6 = { class: "hospital-visit-calendar-input-wrapper" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "hospital-visit-calendar-placeholder"
}
const _hoisted_9 = {
  key: 1,
  class: "hospital-visit-calendar-formatted-date"
}
const _hoisted_10 = {
  for: "visit-date-undecided",
  class: "hospital-visit-visit-date-label"
}
const _hoisted_11 = { class: "hospital-visit-form-label" }
const _hoisted_12 = { class: "hospital-visit-form-time-container" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "hospital-visit-form-item" }
const _hoisted_18 = { class: "hospital-visit-form-label" }
const _hoisted_19 = { for: "hospital-name" }
const _hoisted_20 = { class: "hospital-visit-form-description" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  value: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "hospital-visit-form-item" }
const _hoisted_25 = { class: "hospital-visit-form-label" }
const _hoisted_26 = { for: "department-name" }
const _hoisted_27 = {
  key: 0,
  class: "input-required-error active"
}
const _hoisted_28 = { class: "hospital-visit-form-item clinic" }
const _hoisted_29 = { class: "hospital-visit-form-label" }
const _hoisted_30 = { for: "disease-name" }
const _hoisted_31 = { class: "hospital-visit-disease-info" }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 1,
  value: "",
  selected: ""
}
const _hoisted_34 = { class: "hospital-visit-form-item" }
const _hoisted_35 = { class: "hospital-visit-form-label" }
const _hoisted_36 = { class: "hospital-visit-form-purpose-container" }
const _hoisted_37 = ["id", "value"]
const _hoisted_38 = ["for"]
const _hoisted_39 = {
  key: 0,
  class: "hospital-visit-delete"
}

import dayjs from "dayjs";
import "dayjs/locale/ja";

import {
  onMounted,
  onBeforeUnmount,
  computed,
  ref,
  reactive,
  getCurrentInstance,
} from "vue";
import { useRouter } from "vue-router";
import { processing, processend } from "@/utils/view";
import { _$t } from "@/utils/i18n";
import { createMacSafariDatePickerCloser } from "@/utils/mac-safari-date-picker";

import { HospitalVisit } from "@/models/myRecord/hospitalVisit";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import ConfirmDialog from "@/views/base/CommonMessage.vue";
import Modal from "@/views/base/ModalComponent.vue";

// 日付のローカライズ

export default /*@__PURE__*/_defineComponent({
  __name: 'HospitalVisitEdit',
  props: {
    hospitalVisitId: { default: null }
  },
  emits: ["close", "fetch-hospital-visits"],
  setup(__props: any, { emit: __emit }) {

dayjs.locale("ja");

// ---- props ----------------------------------------
const props = __props;

// ---- Constants & Variables ------------------------------
const router = useRouter();
const hospitalVisitId = ref(props.hospitalVisitId);
// コンポーネントID
const componentId =
  props.hospitalVisitId === null
    ? "healthcaredata02-01-a01"
    : "healthcaredata02-01-a02";
// モーダルタイトル
const title =
  props.hospitalVisitId === null
    ? `${_$t("hospital_visit_title_add")}`
    : `${_$t("hospital_visit_title_edit")}`;
// 保存ボタンのクラス
const classModalSave =
  props.hospitalVisitId === null ? "modal-cansel" : "modal-ok";

// 選択肢
const hospitals = ref<{ id: string; name: string }[]>([]);
const diseases = ref<{ id: string | null; name: string }[]>([]);
const purposes = ref<{ id: string; value: string; label: string }[]>([]);
// 選択値
const visitDateUndecided = ref<boolean>(false);
const selectedVisitHour = ref<string>("");
const selectedVisitMinute = ref<string>("00");
const selectedVisitDate = ref<string>("");
const selectedPurpose = ref<string>("");
const selectedHospital = ref<string>("");
const selectedDisease = ref<string>("");
const inputDepartmentName = ref<string>("");
const isHospitalSelectDisabled = ref<boolean>(false);

// トースト表示用
const { appContext } = getCurrentInstance()!;
const $toast = appContext.config.globalProperties.$toast;

const emit = __emit;

// macOS Safari 向け date picker クローズ処理
const safariDatePickerCloser = createMacSafariDatePickerCloser();

// --- Dialogs -------------------------------------------

// 確認ダイアログ関連情報
let confirmDialogSet = reactive({
  show: false,
  okButtonHide: true,
  okButton: true,
  okName: _$t("hospital_visit_button_ok"),
  cancelButton: true,
  cancelName: _$t("hospital_visit_button_cancel"),
  message: "", // 表示メッセージ
  open: (message: string): void => {
    processing();
    confirmDialogSet.message = message;
    confirmDialogSet.show = true;
  },
  execute: async (): Promise<void> => {
    processend();
    confirmDialogSet.show = false;
    confirmDialogSet.message = "";
    await deleteData();
  },
  close: (): void => {
    processend();
    confirmDialogSet.show = false;
  },
});

// エラーダイアログ関連情報
const fieldErrors = ref<Record<string, string>>({});
const sessionErr = ref(false);
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// --- Functions -------------------------------------------

// 保存処理
async function save(): Promise<boolean> {
  // ## リクエストパラメータの生成 ##############################
  const visitTime =
    selectedVisitHour.value !== "" &&
    selectedVisitHour.value !== null &&
    selectedVisitHour.value !== undefined &&
    selectedVisitMinute.value !== "" &&
    selectedVisitMinute.value !== null &&
    selectedVisitMinute.value !== undefined
      ? `${selectedVisitHour.value}:${selectedVisitMinute.value}`
      : "";
  const params = {
    hospitalVisitId: props.hospitalVisitId,
    diseaseCode: selectedDisease.value,
    visitDate: selectedVisitDate.value,
    visitTime: visitTime,
    visitDateUndecided: visitDateUndecided.value,
    hospitalName: selectedHospital.value,
    hospitalDepartmentName: inputDepartmentName.value,
    visitPurposeOptionId: selectedPurpose.value,
  };
  // 病院受診モデルの生成
  const hospitalVisit = new HospitalVisit();
  hospitalVisit.set(params);

  // ## バリデーションチェック #################################
  let validateResult = hospitalVisit.validate();
  fieldErrors.value = {};
  if (!validateResult.valid) {
    validateResult.errors.forEach((error: any) => {
      fieldErrors.value[error.key] = error.msg;
    });
    return false;
  }

  // ## 保存処理 #################################
  const [_model, response, err] = await hospitalVisit.save();

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return false;
  }
  // 病院受診IDを更新
  hospitalVisitId.value = response.data.hospital_visit_id;
  // 完了トースト表示
  $toast({
    message: `${_$t("hospitalVisit_title")}${_$t("common_message_saved")}`,
    icon: "success",
  });
  onClose();
  emit("fetch-hospital-visits");
  return true;
}

// 削除処理
async function deleteData() {
  // 病院受診モデルの生成
  const hospitalVisit = new HospitalVisit();
  const [_model, _response, err] = await hospitalVisit.delete(
    props.hospitalVisitId
  );

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }

  // 完了メッセージ表示
  $toast({
    message: `${_$t("hospitalVisit_title")}${_$t("common_message_delete")}`,
    icon: "success",
  });
  onClose();
  emit("fetch-hospital-visits");
}

// 初期設定
async function set(hospitalVisitId: number | null = null) {
  // 病院受診モデルの生成
  const hospitalVisit = new HospitalVisit();
  const [model, _response, err] = await hospitalVisit.getData(hospitalVisitId);

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }
  // #### 選択肢の設定 ####
  purposes.value = model.attributes.purposes;
  diseases.value = model.attributes.diseases;
  if (model.attributes.hospitals.length) {
    hospitals.value = model.attributes.hospitals;
  } else {
    isHospitalSelectDisabled.value = true;
  }

  // #### 初期選択 ######
  const hv = model.attributes.hospitalVisit;
  // 目的
  selectedPurpose.value = hv
    ? hv.visit_purpose_option_id
    : purposes.value[0].value;
  // 医療機関名・病名
  selectedHospital.value = hv ? hv.hospital_name : hospitals.value[0]?.id ?? "";
  selectedDisease.value = hv?.disease_code ?? diseases.value[0]?.id ?? "";
  // 診療科名
  inputDepartmentName.value = hv?.hospital_department_name ?? "";
  // 受診日未定
  visitDateUndecided.value = !hospitalVisitId
    ? false
    : !hv?.visit_date
      ? true
      : false;
  // 受診日・時間（visit_timeは"HH:mm"形式の文字列で返されるため、直接分割して選択肢に設定）
  selectedVisitDate.value = hv?.visit_date ?? "";
  const timeStr = hv?.visit_time;
  if (timeStr && typeof timeStr === "string") {
    const m = timeStr.trim().match(/^(\d{1,2}):(\d{2})/);
    if (m) {
      selectedVisitHour.value = String(Number(m[1]));
      selectedVisitMinute.value = m[2].padStart(2, "0");
    } else {
      selectedVisitHour.value = "";
      selectedVisitMinute.value = "00";
    }
  } else {
    selectedVisitHour.value = "";
    selectedVisitMinute.value = "00";
  }
}

// --- Event handlers --------------------------------------------

// 閉じるボタン押下時処理
function onClose() {
  emit("close");
}

// 保存ボタン押下時処理
async function onSave() {
  await save();
}

// 削除ボタン押下時処理
async function onDelete() {
  confirmDialogSet.open(_$t("hospital_visit_message_delete_confirm"));
}

// 続けて診察ノートを作る
async function onCreateNote() {
  const result = await save();
  if (!result || !hospitalVisitId.value) return;

  emit("close");
  emit("fetch-hospital-visits");
  router.push({
    name: "ClinicNote",
    params: { hospitalVisitId: hospitalVisitId.value },
  });
}

function onVisitDateUndecidedChange() {
  if (visitDateUndecided.value) {
    selectedVisitDate.value = "";
  }
}

function onDateSelected(event: Event) {
  safariDatePickerCloser.onDateSelected(event);
}

// --- Vue lifecycle --------------------------------------------
onMounted(async () => {
  // 初期設定
  await set(props.hospitalVisitId);
  safariDatePickerCloser.enableSafariDateInputClass();
});

onBeforeUnmount(() => {
  safariDatePickerCloser.disableSafariDateInputClass();
});

const formattedVisitDate = computed(() => {
  return selectedVisitDate.value
    ? dayjs(selectedVisitDate.value).format("YYYY年M月D日(ddd)")
    : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      id: _unref(componentId),
      title: _unref(title),
      closable: true,
      overlayClosable: true,
      escClosable: true,
      showTab: false,
      actions: [],
      modalClass: "modal-hospital-visit-add",
      onClose: onClose
    }, {
      bodyInfo: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("hospital_visit_label_required")), 1),
          _createElementVNode("div", {
            class: _normalizeClass({
            'hospital-visit-form-item': true,
            'is-disabled': visitDateUndecided.value,
          })
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospital_visit_label_visit_date")), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "hospital-visit-form-label-required" }, "※", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "visit-date",
                  class: "hospital-visit-calendar-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedVisitDate).value = $event)),
                  onChange: onDateSelected,
                  onInput: onDateSelected,
                  disabled: visitDateUndecided.value
                }, null, 40, _hoisted_7), [
                  [_vModelText, selectedVisitDate.value]
                ]),
                (!selectedVisitDate.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("hospital_visit_label_visit_date_placeholder")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(formattedVisitDate.value), 1))
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "visit-date-undecided",
                class: "hospital-visit-visit-date-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visitDateUndecided).value = $event)),
                onChange: onVisitDateUndecidedChange
              }, null, 544), [
                [_vModelCheckbox, visitDateUndecided.value]
              ]),
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("hospital_visit_label_visit_date_not_set")), 1)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass({
            'hospital-visit-form-item': true,
            'is-disabled': visitDateUndecided.value,
          })
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospital_visit_label_visit_time")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("select", {
                class: "hospital-visit-form-time-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedVisitHour).value = $event)),
                disabled: visitDateUndecided.value
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "--", -1)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (n) => {
                  return _createElementVNode("option", {
                    key: n,
                    value: n - 1
                  }, _toDisplayString(n - 1), 9, _hoisted_14)
                }), 64))
              ], 8, _hoisted_13), [
                [_vModelSelect, selectedVisitHour.value]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("span", null, "：", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "hospital-visit-form-time-select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedVisitMinute).value = $event)),
                disabled: visitDateUndecided.value
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (n) => {
                  return _createElementVNode("option", {
                    key: n,
                    value: String(n - 1).padStart(2, '0')
                  }, _toDisplayString(String(n - 1).padStart(2, "0")), 9, _hoisted_16)
                }), 64))
              ], 8, _hoisted_15), [
                [_vModelSelect, selectedVisitMinute.value]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "～", -1))
            ])
          ], 2),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospital_visit_label_medical_institution")), 1)
              ]),
              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("hospital_visit_label_medical_institution_note")), 1)
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "hospital-visit-form-hospital-name-select",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedHospital).value = $event)),
              disabled: isHospitalSelectDisabled.value
            }, [
              (isHospitalSelectDisabled.value)
                ? (_openBlock(), _createElementBlock("option", _hoisted_22, _toDisplayString(_ctx.$t("hospital_visit_label_no_hospital")), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(hospitals.value, (hospital) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: hospital.id,
                      value: hospital.id
                    }, _toDisplayString(hospital.name), 9, _hoisted_23))
                  }), 128))
            ], 8, _hoisted_21), [
              [_vModelSelect, selectedHospital.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospital_visit_label_department")), 1)
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "department-name",
              class: "hospital-visit-form-department-name-input",
              placeholder: "入力してください",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputDepartmentName).value = $event))
            }, null, 512), [
              [_vModelText, inputDepartmentName.value]
            ]),
            (fieldErrors.value.hospitalDepartmentName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(fieldErrors.value.hospitalDepartmentName), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospital_visit_label_disease_name")), 1)
              ]),
              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("hospital_visit_label_disease_name_info")), 1)
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "hospital-visit-form-disease-name-select",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedDisease).value = $event))
            }, [
              (diseases.value.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(diseases.value, (disease, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: disease.id
                    }, _toDisplayString(disease.name), 9, _hoisted_32))
                  }), 128))
                : (_openBlock(), _createElementBlock("option", _hoisted_33, _toDisplayString(_ctx.$t("hospitalVisit_select_option_no_diseases")), 1))
            ], 512), [
              [_vModelSelect, selectedDisease.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospital_visit_label_purpose")), 1),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "hospital-visit-form-label-required" }, "※", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purposes.value, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: item.id,
                    name: "purpose",
                    value: item.value,
                    class: "hospital-visit-form-purpose-radio",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedPurpose).value = $event))
                  }, null, 8, _hoisted_37), [
                    [_vModelRadio, selectedPurpose.value]
                  ]),
                  _createElementVNode("label", {
                    for: item.id,
                    class: "hospital-visit-form-purpose-button"
                  }, _toDisplayString(item.label), 9, _hoisted_38)
                ], 64))
              }), 128))
            ])
          ]),
          (props.hospitalVisitId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: onDelete
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("img", { src: "/server/necs/images/icon_delete_hospital_visit.svg" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospital_visit_button_delete")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      footerButton: _withCtx(() => [
        (props.hospitalVisitId !== null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "modal-cansel",
              onClick: onClose
            }, _toDisplayString(_ctx.$t("hospital_visit_button_cancel")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass([_unref(classModalSave)]),
          onClick: onSave
        }, _toDisplayString(_ctx.$t("hospital_visit_button_save")), 3),
        (props.hospitalVisitId === null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "modal-ok",
              onClick: onCreateNote
            }, _toDisplayString(_ctx.$t("hospital_visit_button_create_note")), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["id", "title"]),
    (_unref(errorDialogSet).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialogSet), {
          onOk: _unref(errorDialogSet).close,
          onCancel: _unref(errorDialogSet).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (_unref(confirmDialogSet).show)
      ? (_openBlock(), _createBlock(ConfirmDialog, _mergeProps({ key: 1 }, _unref(confirmDialogSet), {
          onOk: _unref(confirmDialogSet).execute,
          onCancel: _unref(confirmDialogSet).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})